<template>
    <div class="text-input">
        <input
            ref="input"
            :class="{
                success: state === 'success',
                warning: state === 'warning',
                error: state === 'error',
                'is-open': isOpen,
                'has-icon': icon !== undefined,
            }"
            :type="type"
            :value="_value"
            @input="onValueChanged($event.target.value)"
            @focus="onFocus()"
            @blur="onBlur()"
            @keyup.enter="onEnterPressed()"
            @wheel="preventNumberScroll"
            :placeholder="placeholder"
            v-bind="$attrs"
        />

        <div
            v-if="icon !== undefined"
            class="icon"
        >
            <img
                :src="icon"
                @click="onIconClick()"
            />
        </div>
    </div>
</template>

<script>
import { debounce } from 'lodash';

export default {
    props: {
        value: String | Number,
        type: {
            type: String,
            default: 'text',
        },
        state: {
            // value: 'success' | 'warning' | 'alert',
            type: String,
        },
        isOpen: {
            type: Boolean,
            default: false,
        },
        icon: {
            type: String,
        },
        placeholder: {
            type: String,
            required: false,
        },
        hasDebounce: Boolean,
    },
    data() {
        return {
            _value: null,
            emitValueWithDebounce: debounce((value) => {
                this.emitValue(value);
            }, 1000),
        };
    },
    methods: {
        onValueChanged(value) {
            this._value = value;

            if (this.hasDebounce) {
                this.emitValueWithDebounce(value);
            } else {
                this.emitValue(value);
            }
        },
        emitValue(value) {
            this.$emit('input', value);
            this.$emit('change', value);
        },
        onFocus() {
            this.$emit('focus');
        },
        onBlur() {
            this.$emit('blur');
        },
        onEnterPressed() {
            this.$emit('enter', true);
        },
        preventNumberScroll(event) {
            if (this.type === 'number') {
                event.preventDefault();
            }
        },
        onIconClick() {
            this.$refs.input.focus();
        },
    },
    watch: {
        value: {
            handler(value) {
                this._value = value;
            },
            immediate: true,
        },
    },
};
</script>
